document.addEventListener('DOMContentLoaded', function () {
  const mobileSearch = document.querySelector('#mobile-search');
  const menuSummary = document.querySelector('.header__icon--menu');
  if (!menuSummary) return;

  const hamburgerIcon = menuSummary.querySelector('.hamburger-icon');
  const closeIcon = menuSummary.querySelector('.close-icon');

  menuSummary.closest('details').addEventListener('toggle', function () {
    const isOpen = this.open;

    if (isOpen) {
      hamburgerIcon.style.display = 'none';
      closeIcon.style.display = 'flex';
      document.documentElement.classList.add("drawer-locked-scroll");
      mobileSearch.style.display = "none";
    } else {
      document.documentElement.classList.remove("drawer-locked-scroll");
      hamburgerIcon.style.display = 'flex';
      closeIcon.style.display = 'none';     
    }
  });
});
